import {useAgentStore} from "../store/agentStore";

import { toast } from "react-toastify";

import { useManageWidgetSettingsMutation, useDeleteWidgetSettingsMutation} from "../queries/agents/useAgentsQuery";


export const useWidgetSettings = (agentId, onClose) => {

    const { setSelectedAgent} = useAgentStore();

  const {mutate: manageWidgetSettings, isPending: isManageWidgetSettingsPending} = useManageWidgetSettingsMutation();
  const {mutate: deleteWidgetSettings, isPending: isDeleteWidgetSettingsPending} = useDeleteWidgetSettingsMutation();

  const isLoading = isManageWidgetSettingsPending || isDeleteWidgetSettingsPending;

  const handleManageWidgetSettings = (data) => {
    manageWidgetSettings({agentId, data}, {
        onSuccess: (data) => {
            setSelectedAgent((prev) => ({
                ...prev,
                settings: data,
            }));
            onClose();
            toast.success("Widget settings saved successfully");
        },
        onError: (error) => {
            toast.error(error.message);
        },
    });
  };

  const handleDeleteWidgetSettings = () => {
    deleteWidgetSettings({agentId}, {
        onSuccess: () => {
            toast.success("Widget settings deleted successfully");
            setSelectedAgent((prev) => ({
                ...prev,
                settings: null,
          }));
          onClose();
        },
        onError: (error) => {
            toast.error(error.message);
        },
      });
  };

  return { isLoading, handleManageWidgetSettings, handleDeleteWidgetSettings};
};